// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_NJa","cls2":"CollapsedActivityPreview-cls2__9c CollapsedActivityPreview-cls1_NJa"};